import { render } from "./coupon.vue?vue&type=template&id=bf69d548&scoped=true"
import script from "./coupon.vue?vue&type=script&lang=js"
export * from "./coupon.vue?vue&type=script&lang=js"

import "./coupon.vue?vue&type=style&index=0&id=bf69d548&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bf69d548"

export default script